// extracted by mini-css-extract-plugin
export default {"configurationFooter":"aaa0d89ecc33","banner":"f9fc923f7222"};